class SSOController {

    constructor(_, state, initConfigProvider, securityService, $rootScope, helperService) {
        this.state = state;
        this.errors = null;
        this.environment = initConfigProvider.environment;
        this.securityService = securityService;
        this.rootScope = $rootScope;
        this.helperService = helperService;
    }

    $onInit() {
        this.securityService.ssoAuthenticate().then((response) => this._actOnResponse(response));
    }

    _actOnResponse = (response) => {
        if (response.autheticated) {
            if (this.rootScope.returnUrl) {
                let urlMatch = this.helperService.getMatchingStateByUrl(this.rootScope.urlMatcherForStates, this.rootScope.returnUrl);
                if (urlMatch) {
                    this.state.go(urlMatch.state.name, urlMatch.match);
                    return;
                }

            }
            this.state.go("/.coi.home");
            return;
        }
        //Logout first to ensure all session data and tokens are cleared before letting user log in
        this.securityService.logout();
        this.state.go("auth.login");
    }
}

SSOController.$inject = ['_', '$state', 'initConfigProvider', 'securityService', '$rootScope', 'helperService'];

export default SSOController;


// WEBPACK FOOTER //
// ./app/sso/sso.controller.js